import { useEffect, useState } from "react";
import { Button, Flex } from "antd";
import { useNavigate, useParams } from "react-router-dom";
import { EditOutlined } from "@ant-design/icons";
import globalRequest from "../../../../../utils/global/globalRequest";
import * as Apis from "../../../../../utils/helper/enum";
import toast from "react-hot-toast";
import { changeLoader } from "../../../../../redux/reducers/loader";
import { useDispatch } from "react-redux";
import FullCalendar from "@fullcalendar/react";
import dayGridPlugin from "@fullcalendar/daygrid";
import timeGridPlugin from "@fullcalendar/timegrid";
import {
  convertValueToLable,
  formatDateFunction,
} from "../../../../../utils/helper/utils";
import DriverAddSlot from "../../../../../Modal/DriveAddSlot";

const daysName = [
  "Sunday",
  "Monday",
  "Tuesday",
  "Wednesday",
  "Thursday",
  "Friday",
  "Saturday",
];

const DriverTimeSlots = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  let { id } = useParams();

  const [itemData, setItemData] = useState(false);
  const [holidayData, setHolidayData] = useState(false);
  const [holidayDates, setHolidayDates] = useState([]);
  const [selectedDate, setSelectedDate] = useState(false);
  const [isAddSlotModalOpen, setIsAddSlotModalOpen] = useState(false);

  const handleAddSlotOk = () => {
    setIsAddSlotModalOpen(false);
    setSelectedDate(false);
  };
  const handleAddSlotCancel = () => {
    setIsAddSlotModalOpen(false);
  };

  const [zoneData, setZoneData] = useState(false);

  //get all time slot data from db
  const getDriverTimeSlots = async (driverId) => {
    try {
      let response = await globalRequest(
        Apis.DRIVER_TIME_SLOTE.GET_ALL_TIME_SLOTE,
        "get",
        {},
        {
          params: {
            id: driverId,
            type: "all",
            slotFor: "driver",
          },
        },
        true
      );
      let apiResponse = response?.data;
      if (response?.status === 200) {
        let slotsList = apiResponse?.data?.data || apiResponse?.data || [];
        if (slotsList && !Array.isArray(slotsList) && Array.isArray(slotsList.data)) {
          slotsList = slotsList.data;
        }
        setZoneData(slotsList);
        setHolidayData(apiResponse?.data?.holidays || []);
      } else {
        toast.error(apiResponse?.message);
      }
    } catch (e) {
      toast.error(e?.message);
    }
  };

  const getDriverHolidays = async (driverId) => {
    try {
      let response = await globalRequest(
        Apis.DRIVER_HOLIDAY.GET_ALL_HOLIDAY,
        "get",
        { driverId },
        {},
        true
      );
      let apiResponse = response?.data;
      if (response?.status === 200) {
        setHolidayData(apiResponse?.data || []);
      }
    } catch (e) {
      toast.error(e?.message);
    }
  };

  const fetchdata = async () => {
    await getDriverTimeSlots(id);
  };

  useEffect(() => {
    if (id) {
      fetchdata();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [id]);

  const [daysData, setDaysData] = useState({});

  const [currentWeekDates, setCurrentWeekDates] = useState({
    start: null,
    end: null,
  });

  // Handler to detect the current week's start and end dates
  const handleDatesSet = (dateInfo) => {
    const { start, end } = dateInfo;
    setCurrentWeekDates({
      start: start,
      end: end,
    });
  };

  useEffect(() => {
    if (currentWeekDates.start && currentWeekDates.end) {
      let sunday_data = [];
      let monday_data = [];
      let tuesday_data = [];
      let wednesday_data = [];
      let thursday_data = [];
      let friday_data = [];
      let saturday_data = [];

      let sunday_date = [];
      let monday_date = [];
      let tuesday_date = [];
      let wednesday_date = [];
      let thursday_date = [];
      let friday_date = [];
      let saturday_date = [];

      let holiday_date = [];
      for (let i in holidayData) {
        const startDate = new Date(holidayData[i].startDate);
        const endDate = new Date(holidayData[i].endDate);
        let currentDate1 = new Date(startDate);
        while (currentDate1 <= endDate) {
          holiday_date.push(formatDateFunction(currentDate1, "yyyy-mm-dd"));
          currentDate1.setDate(currentDate1.getDate() + 1);
        }
      }
      setHolidayDates(holiday_date);

      for (
        let currentDate = new Date(currentWeekDates.start);
        currentDate < currentWeekDates.end;
        currentDate.setDate(currentDate.getDate() + 1)
      ) {
        let day = daysName[currentDate.getDay()];
        if (day === "Sunday") sunday_date = new Date(currentDate);
        if (day === "Monday") monday_date = new Date(currentDate);
        if (day === "Tuesday") tuesday_date = new Date(currentDate);
        if (day === "Wednesday") wednesday_date = new Date(currentDate);
        if (day === "Thursday") thursday_date = new Date(currentDate);
        if (day === "Friday") friday_date = new Date(currentDate);
        if (day === "Saturday") saturday_date = new Date(currentDate);

        if (zoneData?.length > 0) {
          for (let zone of zoneData) {
            if (day === "Sunday" && zone.day === day.toLowerCase()) {
              if (zone.type === "day") sunday_data.push(zone);
              else if (
                zone.type === "date" &&
                formatDateFunction(currentDate, "yyyy-mm-dd") === zone.date
              ) {
                sunday_data.push(zone);
              }
            }
            if (day === "Monday" && zone.day === day.toLowerCase()) {
              if (zone.type === "day") monday_data.push(zone);
              else if (
                zone.type === "date" &&
                formatDateFunction(currentDate, "yyyy-mm-dd") === zone.date
              ) {
                monday_data.push(zone);
              }
            }
            if (day === "Tuesday" && zone.day === day.toLowerCase()) {
              if (zone.type === "day") tuesday_data.push(zone);
              else if (
                zone.type === "date" &&
                formatDateFunction(currentDate, "yyyy-mm-dd") === zone.date
              ) {
                tuesday_data.push(zone);
              }
            }
            if (day === "Wednesday" && zone.day === day.toLowerCase()) {
              if (zone.type === "day") wednesday_data.push(zone);
              else if (
                zone.type === "date" &&
                formatDateFunction(currentDate, "yyyy-mm-dd") === zone.date
              ) {
                wednesday_data.push(zone);
              }
            }
            if (day === "Thursday" && zone.day === day.toLowerCase()) {
              if (zone.type === "day") thursday_data.push(zone);
              else if (
                zone.type === "date" &&
                formatDateFunction(currentDate, "yyyy-mm-dd") === zone.date
              ) {
                thursday_data.push(zone);
              }
            }
            if (day === "Friday" && zone.day === day.toLowerCase()) {
              if (zone.type === "day") friday_data.push(zone);
              else if (
                zone.type === "date" &&
                formatDateFunction(currentDate, "yyyy-mm-dd") === zone.date
              ) {
                friday_data.push(zone);
              }
            }
            if (day === "Saturday" && zone.day === day.toLowerCase()) {
              if (zone.type === "day") saturday_data.push(zone);
              else if (
                zone.type === "date" &&
                formatDateFunction(currentDate, "yyyy-mm-dd") === zone.date
              ) {
                saturday_data.push(zone);
              }
            }
          }
        }
        setDaysData({
          sunday: sunday_data,
          sunday_date: sunday_date,
          monday: monday_data,
          monday_date: monday_date,
          tuesday: tuesday_data,
          tuesday_date: tuesday_date,
          wednesday: wednesday_data,
          wednesday_date: wednesday_date,
          thursday: thursday_data,
          thursday_date: thursday_date,
          friday: friday_data,
          friday_date: friday_date,
          saturday: saturday_data,
          saturday_date: saturday_date,
        });
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [currentWeekDates, zoneData, holidayData]);

  const addEditSlot = async () => {
    getDriverTimeSlots(id);
  };

  return (
    <>
      <div className="time-slot relative">
        <div className="text-right">
          <Button
            type="primary"
            size={14}
            icon={<EditOutlined />}
            className="mx-1.5 cursor-pointer"
            onClick={() => {
              localStorage.setItem("currentTab", "3");
              navigate("/driver/timeslots-holidays/edit-hours/" + id);
            }}
          >
            Edit
          </Button>
        </div>
        <FullCalendar
          plugins={[dayGridPlugin, timeGridPlugin]}
          initialView="timeGridWeek"
          headerToolbar={{
            left: "prev,next",
            center: "title",
            right: null,
          }}
          datesSet={handleDatesSet}
        />
        <div className="absolute top-[24px] right-0 bg-green-300 text-white-A700 py-[5px] px-[9px] rounded font-semibold mt-3">
          Weekly View
        </div>
        <Flex gap="small" className="mt-4">
          {/* Sunday */}
          <div className="w-full">
            <Flex vertical gap="small">
              {holidayDates?.includes(
                formatDateFunction(daysData?.sunday_date, "yyyy-mm-dd")
              ) ? (
                <Button className="py-3 h-auto text-sm" type="primary">
                  HOLIDAY
                </Button>
              ) : (
                <>
                  {daysData?.sunday?.map((item, index) => {
                    let ifDateTypeExist = daysData?.sunday?.find(
                      (itm) => itm.type === "date"
                    );

                    if (ifDateTypeExist && item.type === "day") {
                      return null;
                    }

                    return (
                      <div
                        key={index}
                        className="w-full rounded-lg bg-gray-100 py-3 px-1.5 text-center text-sm text-gray-500 cursor-pointer"
                        onClick={() => {
                          setIsAddSlotModalOpen(true);
                          setItemData(item);
                          setSelectedDate(daysData?.sunday_date);
                        }}
                      >
                        {convertValueToLable(item.openTime || item.startTime)} -{" "}
                        {convertValueToLable(item.closeTime || item.endTime)}
                      </div>
                    );
                  })}

                  {daysData?.sunday?.length === 0 ? (
                    <div className="w-full rounded-lg bg-gray-100 py-3 px-1.5 text-center text-sm text-gray-500">
                      Closed
                    </div>
                  ) : null}
                  <Button
                    className="py-3 h-auto text-sm"
                    type="primary"
                    onClick={() => {
                      let ifDateTypeExist = daysData?.sunday?.find(
                        (itm) => itm.type === "date"
                      );
                      setIsAddSlotModalOpen(true);
                      setItemData({ type: ifDateTypeExist ? "date" : "day" });
                      setSelectedDate(daysData?.sunday_date);
                    }}
                  >
                    Add Slot
                  </Button>
                </>
              )}
            </Flex>
          </div>

          {/* Monday */}
          <div className="w-full">
            <Flex vertical gap="small">
              {holidayDates?.includes(
                formatDateFunction(daysData?.monday_date, "yyyy-mm-dd")
              ) ? (
                <Button className="py-3 h-auto text-sm" type="primary">
                  HOLIDAY
                </Button>
              ) : (
                <>
                  {daysData?.monday?.map((item, index) => {
                    let ifDateTypeExist = daysData?.monday?.find(
                      (itm) => itm.type === "date"
                    );

                    if (ifDateTypeExist && item.type === "day") {
                      return null;
                    }
                    return (
                      <div
                        key={index}
                        className="w-full rounded-lg bg-gray-100 py-3 px-1.5 text-center text-sm text-gray-500 cursor-pointer"
                        onClick={() => {
                          setIsAddSlotModalOpen(true);
                          setItemData(item);
                          setSelectedDate(daysData?.monday_date);
                        }}
                      >
                        {convertValueToLable(item.openTime || item.startTime)} -{" "}
                        {convertValueToLable(item.closeTime || item.endTime)}
                      </div>
                    );
                  })}
                  {daysData?.monday?.length === 0 ? (
                    <div className="w-full rounded-lg bg-gray-100 py-3 px-1.5 text-center text-sm text-gray-500">
                      Closed
                    </div>
                  ) : null}
                  <Button
                    className="py-3 h-auto text-sm"
                    type="primary"
                    onClick={() => {
                      let ifDateTypeExist = daysData?.monday?.find(
                        (itm) => itm.type === "date"
                      );
                      setIsAddSlotModalOpen(true);
                      setItemData({ type: ifDateTypeExist ? "date" : "day" });
                      setSelectedDate(daysData?.monday_date);
                    }}
                  >
                    Add Slot
                  </Button>
                </>
              )}
            </Flex>
          </div>

          {/* Tuesday */}
          <div className="w-full">
            <Flex vertical gap="small">
              {holidayDates?.includes(
                formatDateFunction(daysData?.tuesday_date, "yyyy-mm-dd")
              ) ? (
                <Button className="py-3 h-auto text-sm" type="primary">
                  HOLIDAY
                </Button>
              ) : (
                <>
                  {daysData?.tuesday?.map((item, index) => {
                    let ifDateTypeExist = daysData?.tuesday?.find(
                      (itm) => itm.type === "date"
                    );

                    if (ifDateTypeExist && item.type === "day") {
                      return null;
                    }
                    return (
                      <div
                        key={index}
                        className="w-full rounded-lg bg-gray-100 py-3 px-1.5 text-center text-sm text-gray-500 cursor-pointer"
                        onClick={() => {
                          setIsAddSlotModalOpen(true);
                          setItemData(item);
                          setSelectedDate(daysData?.tuesday_date);
                        }}
                      >
                        {convertValueToLable(item.openTime || item.startTime)} -{" "}
                        {convertValueToLable(item.closeTime || item.endTime)}
                      </div>
                    );
                  })}
                  {daysData?.tuesday?.length === 0 ? (
                    <div className="w-full rounded-lg bg-gray-100 py-3 px-1.5 text-center text-sm text-gray-500">
                      Closed
                    </div>
                  ) : null}
                  <Button
                    className="py-3 h-auto text-sm"
                    type="primary"
                    onClick={() => {
                      let ifDateTypeExist = daysData?.tuesday?.find(
                        (itm) => itm.type === "date"
                      );
                      setIsAddSlotModalOpen(true);
                      setItemData({ type: ifDateTypeExist ? "date" : "day" });
                      setSelectedDate(daysData?.tuesday_date);
                    }}
                  >
                    Add Slot
                  </Button>
                </>
              )}
            </Flex>
          </div>

          {/* Wednesday */}
          <div className="w-full">
            <Flex vertical gap="small">
              {holidayDates?.includes(
                formatDateFunction(daysData?.wednesday_date, "yyyy-mm-dd")
              ) ? (
                <Button className="py-3 h-auto text-sm" type="primary">
                  HOLIDAY
                </Button>
              ) : (
                <>
                  {daysData?.wednesday?.map((item, index) => {
                    let ifDateTypeExist = daysData?.wednesday?.find(
                      (itm) => itm.type === "date"
                    );

                    if (ifDateTypeExist && item.type === "day") {
                      return null;
                    }
                    return (
                      <div
                        key={index}
                        className="w-full rounded-lg bg-gray-100 py-3 px-1.5 text-center text-sm text-gray-500 cursor-pointer"
                        onClick={() => {
                          setIsAddSlotModalOpen(true);
                          setItemData(item);
                          setSelectedDate(daysData?.wednesday_date);
                        }}
                      >
                        {convertValueToLable(item.openTime || item.startTime)} -{" "}
                        {convertValueToLable(item.closeTime || item.endTime)}
                      </div>
                    );
                  })}
                  {daysData?.wednesday?.length === 0 ? (
                    <div className="w-full rounded-lg bg-gray-100 py-3 px-1.5 text-center text-sm text-gray-500">
                      Closed
                    </div>
                  ) : null}
                  <Button
                    className="py-3 h-auto text-sm"
                    type="primary"
                    onClick={() => {
                      let ifDateTypeExist = daysData?.wednesday?.find(
                        (itm) => itm.type === "date"
                      );
                      setIsAddSlotModalOpen(true);
                      setItemData({ type: ifDateTypeExist ? "date" : "day" });
                      setSelectedDate(daysData?.wednesday_date);
                    }}
                  >
                    Add Slot
                  </Button>
                </>
              )}
            </Flex>
          </div>

          {/* Thursday */}
          <div className="w-full">
            <Flex vertical gap="small">
              {holidayDates?.includes(
                formatDateFunction(daysData?.thursday_date, "yyyy-mm-dd")
              ) ? (
                <Button className="py-3 h-auto text-sm" type="primary">
                  HOLIDAY
                </Button>
              ) : (
                <>
                  {daysData?.thursday?.map((item, index) => {
                    let ifDateTypeExist = daysData?.thursday?.find(
                      (itm) => itm.type === "date"
                    );

                    if (ifDateTypeExist && item.type === "day") {
                      return null;
                    }
                    return (
                      <div
                        key={index}
                        className="w-full rounded-lg bg-gray-100 py-3 px-1.5 text-center text-sm text-gray-500 cursor-pointer"
                        onClick={() => {
                          setIsAddSlotModalOpen(true);
                          setItemData(item);
                          setSelectedDate(daysData?.thursday_date);
                        }}
                      >
                        {convertValueToLable(item.openTime || item.startTime)} -{" "}
                        {convertValueToLable(item.closeTime || item.endTime)}
                      </div>
                    );
                  })}
                  {daysData?.thursday?.length === 0 ? (
                    <div className="w-full rounded-lg bg-gray-100 py-3 px-1.5 text-center text-sm text-gray-500">
                      Closed
                    </div>
                  ) : null}
                  <Button
                    className="py-3 h-auto text-sm"
                    type="primary"
                    onClick={() => {
                      let ifDateTypeExist = daysData?.thursday?.find(
                        (itm) => itm.type === "date"
                      );
                      setIsAddSlotModalOpen(true);
                      setItemData({ type: ifDateTypeExist ? "date" : "day" });
                      setSelectedDate(daysData?.thursday_date);
                    }}
                  >
                    Add Slot
                  </Button>
                </>
              )}
            </Flex>
          </div>

          {/* Friday */}
          <div className="w-full">
            <Flex vertical gap="small">
              {holidayDates?.includes(
                formatDateFunction(daysData?.friday_date, "yyyy-mm-dd")
              ) ? (
                <Button className="py-3 h-auto text-sm" type="primary">
                  HOLIDAY
                </Button>
              ) : (
                <>
                  {daysData?.friday?.map((item, index) => {
                    let ifDateTypeExist = daysData?.friday?.find(
                      (itm) => itm.type === "date"
                    );

                    if (ifDateTypeExist && item.type === "day") {
                      return null;
                    }
                    return (
                      <div
                        key={index}
                        className="w-full rounded-lg bg-gray-100 py-3 px-1.5 text-center text-sm text-gray-500 cursor-pointer"
                        onClick={() => {
                          setIsAddSlotModalOpen(true);
                          setItemData(item);
                          setSelectedDate(daysData?.friday_date);
                        }}
                      >
                        {convertValueToLable(item.openTime || item.startTime)} -{" "}
                        {convertValueToLable(item.closeTime || item.endTime)}
                      </div>
                    );
                  })}
                  {daysData?.friday?.length === 0 ? (
                    <div className="w-full rounded-lg bg-gray-100 py-3 px-1.5 text-center text-sm text-gray-500">
                      Closed
                    </div>
                  ) : null}
                  <Button
                    className="py-3 h-auto text-sm"
                    type="primary"
                    onClick={() => {
                      let ifDateTypeExist = daysData?.friday?.find(
                        (itm) => itm.type === "date"
                      );
                      setIsAddSlotModalOpen(true);
                      setItemData({ type: ifDateTypeExist ? "date" : "day" });
                      setSelectedDate(daysData?.friday_date);
                    }}
                  >
                    Add Slot
                  </Button>
                </>
              )}
            </Flex>
          </div>

          {/* Saturday */}
          <div className="w-full">
            <Flex vertical gap="small">
              {holidayDates?.includes(
                formatDateFunction(daysData?.saturday_date, "yyyy-mm-dd")
              ) ? (
                <Button className="py-3 h-auto text-sm" type="primary">
                  HOLIDAY
                </Button>
              ) : (
                <>
                  {daysData?.saturday?.map((item, index) => {
                    let ifDateTypeExist = daysData?.saturday?.find(
                      (itm) => itm.type === "date"
                    );

                    if (ifDateTypeExist && item.type === "day") {
                      return null;
                    }
                    return (
                      <div
                        key={index}
                        className="w-full rounded-lg bg-gray-100 py-3 px-1.5 text-center text-sm text-gray-500 cursor-pointer"
                        onClick={() => {
                          setIsAddSlotModalOpen(true);
                          setItemData(item);
                          setSelectedDate(daysData?.saturday_date);
                        }}
                      >
                        {convertValueToLable(item.openTime || item.startTime)} -{" "}
                        {convertValueToLable(item.closeTime || item.endTime)}
                      </div>
                    );
                  })}
                  {daysData?.saturday?.length === 0 ? (
                    <div className="w-full rounded-lg bg-gray-100 py-3 px-1.5 text-center text-sm text-gray-500">
                      Closed
                    </div>
                  ) : null}
                  <Button
                    className="py-3 h-auto text-sm"
                    type="primary"
                    onClick={() => {
                      let ifDateTypeExist = daysData?.saturday?.find(
                        (itm) => itm.type === "date"
                      );
                      setIsAddSlotModalOpen(true);
                      setItemData({ type: ifDateTypeExist ? "date" : "day" });
                      setSelectedDate(daysData?.saturday_date);
                    }}
                  >
                    Add Slot
                  </Button>
                </>
              )}
            </Flex>
          </div>
        </Flex>
        {isAddSlotModalOpen && (
          <DriverAddSlot
            isOpen={isAddSlotModalOpen}
            onOk={handleAddSlotOk}
            onCancel={handleAddSlotCancel}
            selectedDate={selectedDate || null}
            data={itemData || null}
            holidayData={holidayData}
            onSubmit={() => {
              addEditSlot();
            }}
          />
        )}
      </div>
    </>
  );
};

export default DriverTimeSlots;
